export var generateIdempotencyKey = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    var normalized = parts
        .filter(function (p) { return p !== undefined && p !== null; })
        .map(function (p) { return String(p).trim(); })
        .filter(function (p) { return p.length > 0; });
    return btoa(normalized.join(':'));
};
